import {Outlet} from 'react-router-dom';
import {Box} from '@mui/material';

export default function AmenityLayout() {
  return (
    <Box sx={{height: '100%', display: 'flex', flexDirection: 'column'}}>
      <Outlet />
    </Box>
  );
}
